import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import { Close as CloseIcon, LocationOn as LocationOnIcon } from '@mui/icons-material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Leaflet ikon sorununu düzelt
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface TaskLocationModalProps {
  open: boolean;
  onClose: () => void;
  task: any; // Şimdilik any, daha sonra Task tipini belirleyebiliriz
}

const TaskLocationModal: React.FC<TaskLocationModalProps> = ({ open, onClose, task }) => {
  if (!task || !task.completionLocation) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 300 }}>
        <Typography variant="body1" color="text.secondary">
          Bu görev için konum bilgisi bulunamadı.
        </Typography>
      </Box>
    );
  }
  const position: [number, number] = [task.completionLocation.latitude, task.completionLocation.longitude];
  const timestamp = task.completedAt ? new Date(task.completedAt).toLocaleString('tr-TR') : 'Bilinmiyor';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocationOnIcon color="primary" />
          Görev Tamamlanma Konumu
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6">{task.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            Personel: {task.personnelName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tarih: {task.completionDate} {task.completionTime}
          </Typography>
        </Box>
        <Box sx={{ height: '50vh', width: '100%' }}>
          <MapContainer center={position} zoom={16} style={{ height: '400px', width: '100%' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}>
              <Popup>
                {task.name} <br /> {task.personnelName} tarafından burada tamamlandı.
              </Popup>
            </Marker>
          </MapContainer>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskLocationModal;
